module.exports = __webpack_public_path__ + "img/logo_top.bd2cd5da.png";